// extracted by mini-css-extract-plugin
export default {"container":"TaskResponsible_container__QR8X6","title":"TaskResponsible_title__Smf1k"};